import { Icon20GovernmentOutline } from '@vkontakte/icons';
import { Button, Spacing, Text, Title } from '@vkontakte/vkui';
import classNames from 'clsx';
import img from 'img/family/familyDocumentsEmptyState.png';
import imgDark from 'img/family/familyDocumentsEmptyStateDark.png';
import { xray } from 'lib/xray';
import React, { type ReactElement } from 'react';
import { useDispatch } from 'react-redux';
import { isDarkTheme } from 'reactApp/appHelpers/featuresHelpers';
import { familyDocumentsEnableAction } from 'reactApp/modules/family/family.actions';
import styles from 'reactApp/ui/FamilyContentEmpty/FamilyContentEmpty.css';
import { renderFamilyDocumentsModal } from 'reactApp/ui/FamilyDocumentsModal/FamilyDocumentsModal.helper';

export const FamilyDocumentsEmptyState = (): ReactElement => {
    const dispatch = useDispatch();

    const onClick = () => {
        xray.send('empty-family-docs-recognition-on', { p: 'cloud' });
        renderFamilyDocumentsModal({
            onClick: () => {
                dispatch(familyDocumentsEnableAction());
            },
        });
    };
    return (
        <div className={styles.card} onClick={onClick} data-qa-id="family-subscription">
            <div className={styles.icon}>
                <Icon20GovernmentOutline data-qa-id="family-subscription-icon" />
            </div>
            <Spacing size={24} style={{ pointerEvents: 'none' }} />
            <Title level="2" data-qa-id="family-subscription-title">
                Соберите документы{'\n'}семьи в одной папке
            </Title>
            <Spacing size={8} style={{ pointerEvents: 'none' }} />
            <Text data-qa-id="family-subscription-content">
                Включите&nbsp;распознавание,&nbsp;и&nbsp;Облако{'\n'}само&nbsp;найдёт&nbsp;и&nbsp;разложит&nbsp;документы
            </Text>
            <Spacing size={25} style={{ pointerEvents: 'none' }} />
            <Button
                mode="outline"
                appearance="accent-invariable"
                size="l"
                className={classNames(styles.outlineButton, styles.outlineButtonAuto)}
                data-qa-id="family-subscription-button"
            >
                Собрать документы
            </Button>
            <img
                src={isDarkTheme ? imgDark : img}
                alt="Близкие в подписке"
                className={styles.imageDocs}
                data-qa-id="family-subscription-mascot"
            />
        </div>
    );
};
